import React from 'react';

import './News.css';
import { Newsletter } from '../../components';

const News = () => (
  <div className="section--sand section__padding">
    <div className="app__container">
      <Newsletter />
    </div>
  </div>
);

export default News;
